import * as yup from "yup";
import { BundleKey } from "./../../translation/bundleKey";

export const blackListSchema = (translate: any) => {
  const schema = yup.object().shape({
    blacklistAuthorization: yup
      .string()
      .required(translate(BundleKey.ERROR_BLACKLIST_REPONSIBLE)),
  });
  return schema;
};
